import { render, staticRenderFns } from "./PoiMiniCardSummary.vue?vue&type=template&id=0c679e46&"
import script from "./PoiMiniCardSummary.vue?vue&type=script&lang=ts&"
export * from "./PoiMiniCardSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports